import { type ReactNode } from 'react';
import { Pressable, Text as RNText, View } from 'react-native';

import { BOUNDED } from './bounds';
import { cn } from './cn';

export interface NavBarProps {
  /** Show a back chevron and call this on press. */
  onBack?: () => void;
  /** Centered title text. */
  title?: string;
  /** Custom centered node (e.g. a StatusPill) — overrides `title`. */
  center?: ReactNode;
  /** Trailing node (e.g. a "⋯" menu button). */
  right?: ReactNode;
  className?: string;
}

/** Top navigation row: back · center · trailing. */
export function NavBar({ onBack, title, center, right, className }: NavBarProps) {
  return (
    <View className={cn('h-12 flex-row items-center px-2', BOUNDED, className)}>
      <View className="w-12 items-start">
        {onBack ? (
          <Pressable
            onPress={onBack}
            hitSlop={10}
            className="h-10 w-10 items-center justify-center"
          >
            <RNText className="font-sans text-2xl text-foreground">‹</RNText>
          </Pressable>
        ) : null}
      </View>

      <View className="flex-1 items-center">
        {center ??
          (title ? (
            <RNText className="font-heading text-base text-foreground">{title}</RNText>
          ) : null)}
      </View>

      <View className="w-12 items-end">{right}</View>
    </View>
  );
}
